import { useSelectSlice } from "@common/redux/selectors/useSelectSlice";
import { newsSlice } from "@common/redux/slices/entities.slice";
import { INews } from "@common/redux/types/articles";
import { EntitiesGrid } from "@kursk/components/ui/EntitiesGrid/EntitiesGrid";
import { EntityCard } from "@kursk/components/ui/EntityCard/EntityCard";
import { getCardTypeByIdx } from "@kursk/utils/getCardTypeByIdx";
import { useOrientations } from "@common/hooks/useOrientation";
import { useCallback } from "react";

export function NewsGrid() {
  const { items, total, offset } = useSelectSlice(newsSlice);
  const orientation = useOrientations()
  const getCardType = useCallback((index) => {
    return getCardTypeByIdx(index, orientation)
  }, [orientation])

  return (
    <EntitiesGrid
      <INews>
      entityType="news"
      items={items}
      total={total}
      offset={offset}
      renderGridCard={(item: INews, index) => <EntityCard key={item._id} type={getCardType(index)}
        entityType="news" entity={item}/>}
    />
  );
}
